import { illustrationA11y, lineStyle } from './static-art';

export function PaymentConfirmedIllustration(props: { className?: string; label?: string; ink?: string }) {
	const line = lineStyle(props.ink);
	return (
		<svg
			width="193"
			height="184"
			viewBox="0 0 193 184"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M30.7661 119.558C27.4583 122.324 23.7924 126.301 25.3002 130.346C25.779 131.632 26.7364 132.672 27.6751 133.671C34.1681 140.582 40.9306 147.242 47.9382 153.63C50.4223 155.894 53.142 158.222 56.4648 158.698C61.925 159.481 66.6313 155.116 70.4366 151.116C97.1192 123.065 113.394 106.801 141.952 80.668"
				{...line}
			/>
			<path
				d="M141.981 80.5952C148.276 71.4485 159.771 68.9428 169.928 64.4809C171.138 63.9484 172.559 62.959 172.239 61.6731C172.041 60.8819 171.245 60.4193 170.524 60.0435C161.431 55.3211 152.341 50.5986 143.249 45.8742C141.217 44.8186 139.157 43.7537 137.033 42.8945"
				{...line}
			/>
			<path
				d="M30.8223 119.526C58.6527 93.5642 74.7279 78.6546 102.558 52.6932C107.274 48.2936 120.345 33.2934 137.034 42.8895"
				{...line}
			/>
			<path
				d="M171.92 60.9375C176.302 64.2174 178.507 70.1993 178.426 75.679C178.283 85.4355 174.097 95.0693 167.066 101.824C160.036 108.578 150.252 112.364 140.518 112.099"
				{...line}
			/>
			<path
				d="M24.9242 127.715C23.4409 130.143 23.5974 133.538 24.8865 136.074C26.1757 138.612 28.2735 140.625 30.3335 142.587C39.2805 151.108 48.2294 159.632 57.1764 168.153C60.1675 171.001 63.6562 173.837 67.7819 173.807C76.8853 173.741 80.8189 167.874 83.8006 164.498"
				{...line}
			/>
			<path d="M83.8535 164.464C90.2711 159.318 129.269 122.515 140.498 112.086" {...line} />
			<path
				d="M86.3164 153.629C86.6067 150.163 85.21 143.253 92.0442 135.633C104.567 121.667 107.791 118.361 122.08 106.214C123.043 105.394 124.032 104.567 125.197 104.078C126.549 103.512 128.045 103.434 129.504 103.311C134.333 102.902 139.09 101.897 143.832 100.895"
				{...line}
			/>
			<path d="M100.875 54.8594C115.041 63.5396 129.533 72.5994 142.645 79.482" {...line} />
			<path
				d="M36.0405 119.236L96.9165 62.3506C98.1567 61.195 99.9925 60.9552 101.489 61.7502L129.796 79.2202C132.184 80.491 132.637 83.7293 130.688 85.6081L66.6076 147.546C65.1074 148.993 62.7476 149.036 61.1965 147.644L36.0933 125.121C34.3499 123.558 34.3254 120.831 36.0386 119.236H36.0405Z"
				{...line}
			/>
			<path
				d="M94.3987 114.61C104.011 105.888 106.853 93.3424 100.748 86.5895C94.6423 79.8365 81.9008 81.4332 72.2888 90.1557C62.6768 98.8782 59.8342 111.424 65.9397 118.176C72.0452 124.929 84.7868 123.333 94.3987 114.61Z"
				fill="#00A000"
			/>
			<path
				d="M71.0917 109.792C70.6921 109.483 70.5131 108.982 70.628 108.488C71.904 102.919 71.1822 97.923 70.9296 96.5238C70.8372 96.014 71.0276 95.4909 71.4253 95.1586C71.8494 94.8036 72.739 94.3466 73.9302 95.27C75.4832 96.4728 76.8723 99.5374 77.3435 100.653C87.8812 98.3554 93.1359 98.3459 95.6935 98.75C96.0008 98.7991 96.2948 98.9256 96.5417 99.1163C96.9676 99.4468 97.2315 99.9453 97.2617 100.483V100.506C97.3182 101.528 96.5417 102.409 95.5277 102.474C83.2126 103.27 75.9035 107.413 72.6447 109.809C72.1773 110.153 71.5535 110.146 71.0936 109.789L71.0917 109.792Z"
				fill="white"
			/>
		</svg>
	);
}
